// require('./bootstrap');


/**
 * @file Anything that can run on every page
 */

// import { Datepicker } from 'vanillajs-datepicker';
import Inputmask from "inputmask";
import vAdminMenu from './partials/_adminMenu';
import vAdminTheme from './partials/_adminTheme';
import vAdminChart from './partials/_adminChart';
import vAlert from './partials/_alert';
import vForm from './partials/_form';
import vConfirmDialog from './partials/_confirm-dialog';
import vSettings from './partials/_settings';
import vPrint from './partials/_print';
import vFormText from './partials/_form-text';
import vFormSignature from './partials/_form-signature';
import vNav from './partials/_nav';

 /**
  * Global functions
  *
  * Runs component js and any global tasks
  */
 const vGlobal = () => {
    const body            = document.querySelector('body');
    const maskInputs = document.querySelectorAll( 'input[data-inputmask]' );
    const tels = document.querySelectorAll( 'input[type="tel"]' );

    if ( body.hasAttribute('data-route') ) {
        const route = body.getAttribute('data-route');
        vNav();
        if (
            route === 'dashboard'||
            route === 'submissions.index' ||
            route === 'submissions.search' ||
            route === 'settings.index' ||
            route === 'logs'
        ) {
            vAdminMenu();
            vAdminTheme();
        }

        if ( route === 'dashboard' ) {
            vAdminChart();
        }

        if (
            route === 'submissions.index' ||
            route === 'submissions.show' ||
            route === 'submissions.search' ||
            route === 'submissions.showFinancial' ||
            route === 'submissions.showHippa' ||
            route === 'users.index' ||
            route === 'users.edit' ||
            route === 'settings.index'
        ) {
            vAlert();
            vConfirmDialog();
        }

        if (
            route === 'submissions.show' ||
            route === 'submissions.showFinancial' ||
            route === 'submissions.showHippa'
        ) {
            vPrint();
        }

        if (route === 'patient-form' || route === 'submissions.edit') {
            vForm();
        }

        if (route === 'settings.index') {
            vSettings();
        }

        if (
            route === 'submissions.showFinancial' ||
            route === 'settings.showFinancial' ||
            route === 'submissions.showHippa' ||
            route === 'settings.showHippa' ||
            route === 'hippa-form' ||
            route === 'financial-form'
        ) {
            vFormText();
        }

        if (
            route === 'hippa-form' ||
            route === 'financial-form'
        ) {
            vFormSignature();
        }
    }

    const formatPhoneNumber = ( value ) => {
        if ( ! value ) {
            return '';
        }

        const phoneNumber = value.replace(/[^\d]/g, '');

        if ( phoneNumber.length < 4 ) {
            return phoneNumber;
        }

        if ( phoneNumber.length < 7) {
          return `${phoneNumber.slice( 0, 3 )}-${phoneNumber.slice( 3 )}`;
        }

        return `${phoneNumber.slice( 0, 3 ) }-${ phoneNumber.slice( 3, 6 ) }-${ phoneNumber.slice( 6, 10 ) }`;
    };

    tels.forEach( (tel) => {
        tel.addEventListener( 'keyup', (e) => {
            const { target } = e;

            if ( e.key === 'Enter' ) {
                e.preventDefault();
            }

            target.value = formatPhoneNumber( target.value );
        } );
    } );

    [...maskInputs].forEach( ( input ) => {
        const options = input.getAttribute('data-inputmask');
        const masked  = Inputmask( options ).mask( input );

        if ( input.hasAttribute( 'data-max-date' ) ) {
            masked.option( {
                max: input.getAttribute( 'data-max-date' ),
            } );
        }


        /* new Datepicker(
            input,
            (
                input.hasAttribute( 'data-max-date' ) ?
                {
                    ...calendarOptions,
                    maxDate: parseISO( input.getAttribute( 'data-max-date' ) )
                } :
                calendarOptions
            )
        ); */
    });
 };

if ( document.readyState !== 'loading' ) {
    vGlobal();
} else {
    document.addEventListener( 'DOMContentLoaded', vGlobal );
}
